import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { AppLocale, BAND_NAME, BAND_NAME_JP } from 'constant';

import { LanguageContext } from 'context/languageContext';

import Container from 'components/Container';

import {
  Wrapper
} from './Footer.styles';

export interface FooterProps {
  className?: string;
}

const Footer = ({ className = '' }: FooterProps) => {
  const intl = useIntl();
  const { locale } = useContext(LanguageContext);

  const year = new Date().getFullYear();

  return (
    <Wrapper className={className}>
      <Container>
        <p>
          {intl.formatMessage({ id: 'footer.disclaimer' }, {
            bandName: locale === AppLocale.EN ? BAND_NAME : BAND_NAME_JP
          })}
        </p>
        <p>{intl.formatMessage({ id: 'footer.rightNotice' }, { year })}</p>
        <p><Link to="/privacy-policy">{intl.formatMessage({ id: 'privacyPolicy.title' })}</Link></p>
      </Container>
    </Wrapper>
  );
};

export default Footer;
